/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadOrganizationImageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UploadOrganizationImageRequest = {
  contentLength: number;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type UploadOrganizationImageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UploadOrganizationImageSecurity$outboundSchema: z.ZodMiniType<
  UploadOrganizationImageSecurity$Outbound,
  UploadOrganizationImageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadOrganizationImageSecurityToJSON(
  uploadOrganizationImageSecurity: UploadOrganizationImageSecurity,
): string {
  return JSON.stringify(
    UploadOrganizationImageSecurity$outboundSchema.parse(
      uploadOrganizationImageSecurity,
    ),
  );
}

/** @internal */
export type UploadOrganizationImageRequest$Outbound = {
  "Content-Length": number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const UploadOrganizationImageRequest$outboundSchema: z.ZodMiniType<
  UploadOrganizationImageRequest$Outbound,
  UploadOrganizationImageRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramSession: "Gram-Session",
    });
  }),
);

export function uploadOrganizationImageRequestToJSON(
  uploadOrganizationImageRequest: UploadOrganizationImageRequest,
): string {
  return JSON.stringify(
    UploadOrganizationImageRequest$outboundSchema.parse(
      uploadOrganizationImageRequest,
    ),
  );
}
